export { LoginService } from './login/login.service'
export { RolesService } from './roles/roles.service';
export { AccountService } from './account/accounts.service'
export { LeadsService } from './leads/leads.service';
export { UsersService } from './users/users.service';
export { BranchsService } from './branch/branchs.service';
export { CompanyService } from './profile/company.service';
export { UserprofileService } from './profile/userprofile.service';
export { RateService } from './rates/rate.service';
export { CountryService } from './country/country.service';
export { DashboardService } from './dashboard/dashboard.service';
export { OrderService } from './order/order.service';
export { CommentsService } from './comments/comments.service';
export { ReportsService } from './reports/reports.service';
export { TransactionsService } from './transactions/transactions.service';
export { AuditService } from './audit/audit.service';


// WEBPACK FOOTER //
// ./src/app/_services/index.ts